export var Catalog;
(function (Catalog) {
    /**
     * Load bundlegit
     */
    let Bundle;
    (function (Bundle) {
        Bundle.path = 'bundle';
    })(Bundle = Catalog.Bundle || (Catalog.Bundle = {}));
    /**
     * Load catalog models from mongo db
     */
    let CategoryProducts;
    (function (CategoryProducts) {
        CategoryProducts.path = 'categoryProducts';
    })(CategoryProducts = Catalog.CategoryProducts || (Catalog.CategoryProducts = {}));
    /**
     * Invalidates cache
     */
    let Ci;
    (function (Ci) {
        Ci.path = 'catalog/ci';
    })(Ci = Catalog.Ci || (Catalog.Ci = {}));
    /**
     * Find alternate catalog models from mongo db
     */
    let FindAlternate;
    (function (FindAlternate) {
        FindAlternate.path = 'findAlternate';
    })(FindAlternate = Catalog.FindAlternate || (Catalog.FindAlternate = {}));
    /**
     * Find catalog models from mongo db
     */
    let Find;
    (function (Find) {
        Find.path = 'find';
    })(Find = Catalog.Find || (Catalog.Find = {}));
    /**
     * Load catalog models from mongo db
     */
    let Load;
    (function (Load) {
        Load.path = 'load';
    })(Load = Catalog.Load || (Catalog.Load = {}));
    /**
     * Load meta data
     */
    let Meta;
    (function (Meta) {
        Meta.path = 'meta';
    })(Meta = Catalog.Meta || (Catalog.Meta = {}));
    /**
     * Route catalog models from mongo db
     */
    let Route;
    (function (Route) {
        Route.path = 'route';
    })(Route = Catalog.Route || (Catalog.Route = {}));
})(Catalog || (Catalog = {}));
